import workspaceQuery from 'graphql/queries/system/JobInfoWorkspaceQuery.graphql';

const JobInfo = {
  type: 'JobInfo',
  title: 'Active Background Jobs',
  workspaceUrl: '/System/Jobs/Workspace/',
  workspace: workspaceQuery,
  screenReference: 'JOB_INFO',
};

export default JobInfo;
